'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index$1 = require('../../../node_modules/classnames/index.js');

var index = require('../../../node_modules/prop-types/index.js');

var useExternalLink = require('../../../utilities/hooks/useExternalLink.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var Panel = function Panel(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      link = _ref.link,
      description = _ref.description;
  var LinkTag = link ? useExternalLink.GatsbyLink : 'span';
  var linkClasses = index$1['default']('lanl-panel-title', link && 'isLink');

  var renderDescription = function renderDescription() {
    return description && /*#__PURE__*/React__default['default'].createElement("p", {
      className: "lanl-panel-description"
    }, description);
  };

  return /*#__PURE__*/React__default['default'].createElement(LinkTag, {
    href: link,
    "data-test": "panel",
    key: title,
    className: "lanl-panel"
  }, icon, /*#__PURE__*/React__default['default'].createElement("h3", {
    className: linkClasses
  }, title), renderDescription());
};

Panel.defaultProps = {};
Panel.propTypes = {
  description: index['default'].string,
  icon: index['default'].node,
  link: index['default'].string,
  title: index['default'].string
};
exports.Panel = Panel;
exports['default'] = Panel;